'use strict';

import anime from 'animejs';

export default class SlideCrousel {
	constructor(element, settings) {
		this.rootElement = element;
		this.settings = settings;

		this.imgContainer = this.rootElement.getElementsByClassName(this.settings.list)[0];
		if (this.imgContainer.childNodes.length == 0) return;

		this.images = this.imgContainer.getElementsByTagName("li");
		this.maxNum = this.images.length;

		this.cloneElementNum = this.settings.element;
		this.isLoop = this.images.length > this.settings.element;
		this.unit = this.settings.slideUnit;
		this.length = this.settings.slideDistance;
		this.slideInterval = this.settings.slideInterval;

		//
		let slideWrapper = this.rootElement.getElementsByClassName(this.settings.wrapper)[0];
		if (this.settings.wrapper != "" && slideWrapper) {
			slideWrapper.addEventListener("mouseover", event => this.stopAutoSlide());
			slideWrapper.addEventListener("mouseout", event => this.startAutoSlide());
		}

		// clone
		if (this.isLoop) {
			let endNodes = [];
			let firstNodes = [];
			for (let i = 0; i < this.cloneElementNum; i++) {
				let node = this.images[i].cloneNode(true);
				node.classList.add('clone');
				endNodes.push(node);

				node = this.images[cycle(this.maxNum - i - 1, 0, this.maxNum)].cloneNode(true);
				node.classList.add('clone');
				firstNodes.push(node);
			}

			for (let j = 0; j < endNodes.length; j++) {
				this.imgContainer.appendChild(endNodes[j]);
				this.imgContainer.insertBefore(firstNodes[j], this.images[0]);
			}
		}

		let arrowRootElement = this.rootElement.getElementsByClassName(this.settings.buttons)[0];
		if (this.settings.buttons != "" && arrowRootElement) {
			this.nextArrow = arrowRootElement.getElementsByClassName("-next")[0];
			this.nextArrow.addEventListener("click", event => this.next());
			this.nextArrow.addEventListener("mouseover", event => this.stopAutoSlide());
			this.nextArrow.addEventListener("mouseout", event => this.startAutoSlide());

			this.prevArrow = arrowRootElement.getElementsByClassName("-prev")[0];
			this.prevArrow.addEventListener("click", event => this.prev());
			this.prevArrow.addEventListener("mouseover", event => this.stopAutoSlide());
			this.prevArrow.addEventListener("mouseout", event => this.startAutoSlide());
		}


		let navContainer = this.rootElement.getElementsByClassName(this.settings.nav)[0];
		if (navContainer != undefined) {
			this.navigations = navContainer.getElementsByTagName("li");
		}

		// 要素が足りている場合のみスライド
		if (this.isLoop) {
			this.setCurrent(0);
			this.slide = 0;

			this.startAutoSlide();
		}
	}

	startAutoSlide() {
		if (this.slideInterval == 0) return;
		this.slideIntervalId = setInterval(() => this.next(), this.slideInterval);
	}

	stopAutoSlide() {
		if (this.slideIntervalId) {
			clearInterval(this.slideIntervalId);
			this.slideIntervalId = null;
		}
	}

	setCurrent(num) {
		this.setNav(num);

		if (this.anime) {
			this.anime.pause();
		}

		this.anime = anime({
			targets: this,
			slide:num,
			easing:'easeOutCubic',
			duration: 450,
			update: () => {
				let translate = (cycle(this.slide,  0, this.maxNum) + this.cloneElementNum) * -this.length;
				this.imgContainer.style.transform = "translateX(" + translate + this.unit + ")";
			},
			complete: ()=> {
				this.anime = null;
			}
		});

		this.current = num;
	}

	setNav(num) {
		if (this.navigations == undefined) return;

		// prev nav
		if (this.current != undefined) {
			let prevNav = this.navigations[cycle(this.current, 0, this.maxNum)];
			prevNav.classList.remove("-current");
		}

		// current nav
		let currentNav = this.navigations[cycle(num, 0, this.maxNum)];
		currentNav.classList.add("-current");
	}

	next() {
		this.setCurrent(this.current + 1);
	}

	prev() {
		this.setCurrent(this.current - 1);
	}
}

function cycle(value, min, max) {
	let distance = max - min;
	return (value % distance + distance) % distance + min;
}

function range(value, min, max) {
	return (max - min) * value + min;
}


// WEBPACK FOOTER //
// ./assets/js/SlideCrousel.js